// Link Images for DisplayLink component
import goodOnYouImg from "../assets/images/Links/goodOnYouImg.png";
import bcorpImg from "../assets/images/Links/bcorpImg.png";
import chooseManufactureImg from "../assets/images/Links/chooseManufactureImg.png";
import textileProducImg from "../assets/images/Links/textileProducImg.png";
import fashionPlagiarismImg from "../assets/images/Links/fashionPlagiarismImg.png";
import fashionEthicsImg from "../assets/images/Links/fashionEthicsImg.png";
import factoryAuditImg from "../assets/images/Links/factoryAuditImg.png";

import ecoPfp from "../assets/images/FinalPersona/GreenGuardian.svg";
import moralPfp from "../assets/images/FinalPersona/MoralInnovator.svg";
import cashPfp from "../assets/images/FinalPersona/CashCow.svg";
import vanguardVPfp from "../assets/images/FinalPersona/VanguardVisionaryPFP.svg";
import trueArtisanPfp from "../assets/images/FinalPersona/trueArtisan.svg";
import consciousBuilderPfp from "../assets/images/FinalPersona/consciousBuilder.svg";
import ecoEconomistPfp from "../assets/images/FinalPersona/ecoEconomist.svg";
import hiddenLabelPfp from "../assets/images/FinalPersona/hiddenLabel.svg";

import w_eco from "../assets/images/FinalPersona/White/GreenGuardian.svg";
import w_moral from "../assets/images/FinalPersona/White/MoralInnovator.svg";
import w_cash from "../assets/images/FinalPersona/White/CashCow.svg";
import w_visionary from "../assets/images/FinalPersona/White/VanguardVisionary.svg";
import w_trueArtisan from "../assets/images/FinalPersona/White/trueArtisan.svg";  
import w_consciousBuilder from "../assets/images/FinalPersona/White/consciousBuilder.svg";  
import w_ecoEconomist from "../assets/images/FinalPersona/White/ecoEconomist.svg";
import w_hiddenLabel from "../assets/images/FinalPersona/White/hiddenLabel.svg";

import bg_eco from "../assets/images/FinalPersona/greenChampionBg.svg";
import bg_moral from "../assets/images/FinalPersona/moralInnovatorBg.svg";
import bg_cash from "../assets/images/FinalPersona/cashCowBg.svg";
import bg_visionary from "../assets/images/FinalPersona/vanguardVisionaryBg.svg";
import bg_trueArtisan from "../assets/images/FinalPersona/trueArtisanBg.svg";
import bg_consciousBuilder from "../assets/images/FinalPersona/consciousBuilderBg.svg";
import bg_ecoEconomist from "../assets/images/FinalPersona/ecoEconomistBg.svg";
import bg_hiddenLabel from "../assets/images/FinalPersona/hiddenLabelBg.svg";



import testImg  from "../assets/images/FinalPersona/testGreenChampion.svg";
const personaData = {
    ecoWarrior: {
        personaImage: ecoPfp,
        whiteLogo: w_eco,
        bg: bg_eco,
        personaName: "Green Champion",
        personaDescription: "The brand prioritizes sustainable business decisions, seeking to minimize waste and carbon footprints. ",
        pathTitle: "THE PATH TO SUSTAINABLE FASHION CONSUMPTION",
        displayLinkProps: {
            height: "192px",
            width: "410px",
            imageSrc: goodOnYouImg,
            linkImgSize: "160px",
            title: "Use a Fashion Brand Rater",
            link: "https://directory.goodonyou.eco/?_ga=2.200511335.814920322.1743113847-912855162.1736355678&_gl=1*1vvxju3*_ga*OTEyODU1MTYyLjE3MzYzNTU2Nzg.*_ga_TTB1J3Q9MN*MTc0MzExMzg0Ni4xMC4xLjE3NDMxMTM4NTcuNDkuMC4w",
            description: "Quickly search for a brand on Good on You and see it’s rating on the planet, people, and animals"
        },
        displayLinkProps2: {
            height: "192px",
            width: "410px",
            imageSrc: bcorpImg,
            linkImgSize: "160px",
            title: "Learn About B-Corp Brands",
            link: "https://usca.bcorporation.net/17-ethical-fashion-b-corps/",
            description: "Brands that are B-Corp Certified show that they meet high standards on social and environmental impact"
        },
        displayLinkProps3: {
            height: "192px",
            width: "410px",
            imageSrc: chooseManufactureImg,
            linkImgSize: "160px",
            title: "How to Make Sure You Choose a Sustainable Manufacturer for Your Fashion Brand",
            link: "https://blog.sourcingplayground.com/how-to-make-sure-you-choose-a-sustainable-manufacturer-for-your-fashion-brand/"
        },
        displayLinkProps4: {
            height: "192px",
            width: "410px",
            imageSrc: textileProducImg,
            linkImgSize: "160px",
            title: "The Impact of Textile Production and Waste on the Environment",
            link: "https://www.europarl.europa.eu/topics/en/article/20201208STO93327/the-impact-of-textile-production-and-waste-on-the-environment-infographics"
        },
        displayLinkProps5: {
            height: "192px",
            width: "410px",
            imageSrc: fashionPlagiarismImg,
            linkImgSize: "160px",
            title: "Plagiarism in Fashion: Why is There so much Counterfeiting",
            link: "https://fashionunited.uk/news/background/plagiarism-in-fashion-why-is-there-so-much-counterfeiting-and-is-it-even-allowed/2024022974359"
        },
        displayLinkProps6: {
            height: "192px",
            width: "410px",
            imageSrc: fashionEthicsImg,
            linkImgSize: "160px",
            title: "Ethical Practices in the Apparel and Textile Industry",
            link: "https://www.3-tree.com/blog/ethical-practices-in-the-apparel-and-textile-industry/"
        },
        displayLinkProps7: {
            height: "192px",
            width: "410px",
            imageSrc: factoryAuditImg,
            linkImgSize: "160px",
            title: "What Exactly Does It Mean When a Factory Is Audited?",
            link: "https://fashionista.com/2023/09/fashion-factory-labor-safety-audit"
        },
        personaCardImage: testImg
    },
    moralInnovator: {
        personaImage: moralPfp,
        whiteLogo: w_moral,
        bg: bg_moral,
        personaName: "Moral Innovator",
        personaDescription: "The brand prioritized ethical decisions that ensured fair wages and proper working conditions for your workers",
        pathTitle: "THE PATH TO SUSTAINABLE FASHION CONSUMPTION",
        displayLinkProps: {
            height: "192px",
            width: "410px",
            imageSrc: goodOnYouImg,
            linkImgSize: "160px",
            title: "Use a Fashion Brand Rater",
            link: "https://directory.goodonyou.eco/?_ga=2.200511335.814920322.1743113847-912855162.1736355678&_gl=1*1vvxju3*_ga*OTEyODU1MTYyLjE3MzYzNTU2Nzg.*_ga_TTB1J3Q9MN*MTc0MzExMzg0Ni4xMC4xLjE3NDMxMTM4NTcuNDkuMC4w",
            description: "Quickly search for a brand on Good on You and see it’s rating on the planet, people, and animals"
        },
        displayLinkProps2: {
            height: "192px",
            width: "410px",
            imageSrc: bcorpImg,
            linkImgSize: "160px",
            title: "Learn About B-Corp Brands",
            link: "https://usca.bcorporation.net/17-ethical-fashion-b-corps/",
            description: "Brands that are B-Corp Certified show that they meet high standards on social and environmental impact"
        },
        displayLinkProps3: {
            height: "192px",
            width: "410px",
            imageSrc: chooseManufactureImg,
            linkImgSize: "160px",
            title: "How to Make Sure You Choose a Sustainable Manufacturer for Your Fashion Brand",
            link: "https://blog.sourcingplayground.com/how-to-make-sure-you-choose-a-sustainable-manufacturer-for-your-fashion-brand/"
        },
        displayLinkProps4: {
            height: "192px",
            width: "410px",
            imageSrc: textileProducImg,
            linkImgSize: "160px",
            title: "The Impact of Textile Production and Waste on the Environment",
            link: "https://www.europarl.europa.eu/topics/en/article/20201208STO93327/the-impact-of-textile-production-and-waste-on-the-environment-infographics"
        },
        displayLinkProps5: {
            height: "192px",
            width: "410px",
            imageSrc: fashionPlagiarismImg,
            linkImgSize: "160px",
            title: "Plagiarism in Fashion: Why is There so much Counterfeiting",
            link: "https://fashionunited.uk/news/background/plagiarism-in-fashion-why-is-there-so-much-counterfeiting-and-is-it-even-allowed/2024022974359"
        },
        displayLinkProps6: {
            height: "192px",
            width: "410px",
            imageSrc: fashionEthicsImg,
            linkImgSize: "160px",
            title: "Ethical Practices in the Apparel and Textile Industry",
            link: "https://www.3-tree.com/blog/ethical-practices-in-the-apparel-and-textile-industry/"
        },
        displayLinkProps7: {
            height: "192px",
            width: "410px",
            imageSrc: factoryAuditImg,
            linkImgSize: "160px",
            title: "What Exactly Does It Mean When a Factory Is Audited?",
            link: "https://fashionista.com/2023/09/fashion-factory-labor-safety-audit"
        },
        personaCardImage: testImg
    },
    // Add more personas as needed
    cashCow: {
        personaImage: cashPfp,
        whiteLogo: w_cash,
        bg: bg_cash,
        personaName: "CA$H COW",
        personaDescription: "The brand thrives on efficiency and maximizing value, providing the best value for customers while keeping an eye on profit margins. ",
        pathTitle: "THE PATH TO SUSTAINABLE FASHION CONSUMPTION",
        displayLinkProps: {
            height: "192px",
            width: "410px",
            imageSrc: goodOnYouImg,
            linkImgSize: "160px",
            title: "Use a Fashion Brand Rater",
            link: "https://directory.goodonyou.eco/?_ga=2.200511335.814920322.1743113847-912855162.1736355678&_gl=1*1vvxju3*_ga*OTEyODU1MTYyLjE3MzYzNTU2Nzg.*_ga_TTB1J3Q9MN*MTc0MzExMzg0Ni4xMC4xLjE3NDMxMTM4NTcuNDkuMC4w",
            description: "Quickly search for a brand on Good on You and see it’s rating on the planet, people, and animals"
        },
        displayLinkProps2: {
            height: "192px",
            width: "410px",
            imageSrc: bcorpImg,
            linkImgSize: "160px",
            title: "Learn About B-Corp Brands",
            link: "https://usca.bcorporation.net/17-ethical-fashion-b-corps/",
            description: "Brands that are B-Corp Certified show that they meet high standards on social and environmental impact"
        },
        displayLinkProps3: {
            height: "192px",
            width: "410px",
            imageSrc: chooseManufactureImg,
            linkImgSize: "160px",
            title: "How to Make Sure You Choose a Sustainable Manufacturer for Your Fashion Brand",
            link: "https://blog.sourcingplayground.com/how-to-make-sure-you-choose-a-sustainable-manufacturer-for-your-fashion-brand/"
        },
        displayLinkProps4: {
            height: "192px",
            width: "410px",
            imageSrc: textileProducImg,
            linkImgSize: "160px",
            title: "The Impact of Textile Production and Waste on the Environment",
            link: "https://www.europarl.europa.eu/topics/en/article/20201208STO93327/the-impact-of-textile-production-and-waste-on-the-environment-infographics"
        },
        displayLinkProps5: {
            height: "192px",
            width: "410px",
            imageSrc: fashionPlagiarismImg,
            linkImgSize: "160px",
            title: "Plagiarism in Fashion: Why is There so much Counterfeiting",
            link: "https://fashionunited.uk/news/background/plagiarism-in-fashion-why-is-there-so-much-counterfeiting-and-is-it-even-allowed/2024022974359"
        },
        displayLinkProps6: {
            height: "192px",
            width: "410px",
            imageSrc: fashionEthicsImg,
            linkImgSize: "160px",
            title: "Ethical Practices in the Apparel and Textile Industry",
            link: "https://www.3-tree.com/blog/ethical-practices-in-the-apparel-and-textile-industry/"
        },
        displayLinkProps7: {
            height: "192px",
            width: "410px",
            imageSrc: factoryAuditImg,
            linkImgSize: "160px",
            title: "What Exactly Does It Mean When a Factory Is Audited?",
            link: "https://fashionista.com/2023/09/fashion-factory-labor-safety-audit"
        },
        personaCardImage: testImg
    },
    vanguardVisionary: {
        personaImage: vanguardVPfp,
        whiteLogo: w_visionary,
        bg: bg_visionary,
        personaName: "VANGUARD VISIONARY",
        personaDescription: "The brand strategically catered to the environment, ethics, and profits. Doing good for the world and doing well in business go hand in hand!",
        pathTitle: "THE PATH TO SUSTAINABLE FASHION CONSUMPTION",
        displayLinkProps: {
            height: "192px",
            width: "410px",
            imageSrc: goodOnYouImg,
            linkImgSize: "160px",
            title: "Use a Fashion Brand Rater",
            link: "https://directory.goodonyou.eco/?_ga=2.200511335.814920322.1743113847-912855162.1736355678&_gl=1*1vvxju3*_ga*OTEyODU1MTYyLjE3MzYzNTU2Nzg.*_ga_TTB1J3Q9MN*MTc0MzExMzg0Ni4xMC4xLjE3NDMxMTM4NTcuNDkuMC4w",
            description: "Quickly search for a brand on Good on You and see it’s rating on the planet, people, and animals"
        },
        displayLinkProps2: {
            height: "192px",
            width: "410px",
            imageSrc: bcorpImg,
            linkImgSize: "160px",
            title: "Learn About B-Corp Brands",
            link: "https://usca.bcorporation.net/17-ethical-fashion-b-corps/",
            description: "Brands that are B-Corp Certified show that they meet high standards on social and environmental impact"
        },
        displayLinkProps3: {
            height: "192px",
            width: "410px",
            imageSrc: chooseManufactureImg,
            linkImgSize: "160px",
            title: "How to Make Sure You Choose a Sustainable Manufacturer for Your Fashion Brand",
            link: "https://blog.sourcingplayground.com/how-to-make-sure-you-choose-a-sustainable-manufacturer-for-your-fashion-brand/"
        },
        displayLinkProps4: {
            height: "192px",
            width: "410px",
            imageSrc: textileProducImg,
            linkImgSize: "160px",
            title: "The Impact of Textile Production and Waste on the Environment",
            link: "https://www.europarl.europa.eu/topics/en/article/20201208STO93327/the-impact-of-textile-production-and-waste-on-the-environment-infographics"
        },
        displayLinkProps5: {
            height: "192px",
            width: "410px",
            imageSrc: fashionPlagiarismImg,
            linkImgSize: "160px",
            title: "Plagiarism in Fashion: Why is There so much Counterfeiting",
            link: "https://fashionunited.uk/news/background/plagiarism-in-fashion-why-is-there-so-much-counterfeiting-and-is-it-even-allowed/2024022974359"
        },
        displayLinkProps6: {
            height: "192px",
            width: "410px",
            imageSrc: fashionEthicsImg,
            linkImgSize: "160px",
            title: "Ethical Practices in the Apparel and Textile Industry",
            link: "https://www.3-tree.com/blog/ethical-practices-in-the-apparel-and-textile-industry/"
        },
        displayLinkProps7: {
            height: "192px",
            width: "410px",
            imageSrc: factoryAuditImg,
            linkImgSize: "160px",
            title: "What Exactly Does It Mean When a Factory Is Audited?",
            link: "https://fashionista.com/2023/09/fashion-factory-labor-safety-audit"
        },
        personaCardImage: testImg
    },
    consciousBuilder: {
        personaImage: consciousBuilderPfp,
        whiteLogo: w_consciousBuilder,
        bg: bg_consciousBuilder,
        personaName: "CONSCIOUS BUILDER",
        personaDescription: "The brand strategically focuses on equitable business practices that also support your path for growth and profitability.",
        pathTitle: "THE PATH TO SUSTAINABLE FASHION CONSUMPTION",
        displayLinkProps: {
            height: "192px",
            width: "410px",
            imageSrc: goodOnYouImg,
            linkImgSize: "160px",
            title: "Use a Fashion Brand Rater",
            link: "https://directory.goodonyou.eco/?_ga=2.200511335.814920322.1743113847-912855162.1736355678&_gl=1*1vvxju3*_ga*OTEyODU1MTYyLjE3MzYzNTU2Nzg.*_ga_TTB1J3Q9MN*MTc0MzExMzg0Ni4xMC4xLjE3NDMxMTM4NTcuNDkuMC4w",
            description: "Quickly search for a brand on Good on You and see it’s rating on the planet, people, and animals"
        },
        displayLinkProps2: {
            height: "192px",
            width: "410px",
            imageSrc: bcorpImg,
            linkImgSize: "160px",
            title: "Learn About B-Corp Brands",
            link: "https://usca.bcorporation.net/17-ethical-fashion-b-corps/",
            description: "Brands that are B-Corp Certified show that they meet high standards on social and environmental impact"
        },
        displayLinkProps3: {
            height: "192px",
            width: "410px",
            imageSrc: chooseManufactureImg,
            linkImgSize: "160px",
            title: "How to Make Sure You Choose a Sustainable Manufacturer for Your Fashion Brand",
            link: "https://blog.sourcingplayground.com/how-to-make-sure-you-choose-a-sustainable-manufacturer-for-your-fashion-brand/"
        },
        displayLinkProps4: {
            height: "192px",
            width: "410px",
            imageSrc: textileProducImg,
            linkImgSize: "160px",
            title: "The Impact of Textile Production and Waste on the Environment",
            link: "https://www.europarl.europa.eu/topics/en/article/20201208STO93327/the-impact-of-textile-production-and-waste-on-the-environment-infographics"
        },
        displayLinkProps5: {
            height: "192px",
            width: "410px",
            imageSrc: fashionPlagiarismImg,
            linkImgSize: "160px",
            title: "Plagiarism in Fashion: Why is There so much Counterfeiting",
            link: "https://fashionunited.uk/news/background/plagiarism-in-fashion-why-is-there-so-much-counterfeiting-and-is-it-even-allowed/2024022974359"
        },
        displayLinkProps6: {
            height: "192px",
            width: "410px",
            imageSrc: fashionEthicsImg,
            linkImgSize: "160px",
            title: "Ethical Practices in the Apparel and Textile Industry",
            link: "https://www.3-tree.com/blog/ethical-practices-in-the-apparel-and-textile-industry/"
        },
        displayLinkProps7: {
            height: "192px",
            width: "410px",
            imageSrc: factoryAuditImg,
            linkImgSize: "160px",
            title: "What Exactly Does It Mean When a Factory Is Audited?",
            link: "https://fashionista.com/2023/09/fashion-factory-labor-safety-audit"
        },
        personaCardImage: testImg
    },
    trueArtisan: {
        personaImage: trueArtisanPfp,
        whiteLogo: w_trueArtisan,
        bg: bg_trueArtisan,
        personaName: "TRUE ARTISAN",
        personaDescription: "The brand strategically focuses on sustainable and equitable business practices, ensuring that your path supports long-term environmental health and social responsibility.",
        pathTitle: "THE PATH TO SUSTAINABLE FASHION CONSUMPTION",
        displayLinkProps: {
            height: "192px",
            width: "410px",
            imageSrc: goodOnYouImg,
            linkImgSize: "160px",
            title: "Use a Fashion Brand Rater",
            link: "https://directory.goodonyou.eco/?_ga=2.200511335.814920322.1743113847-912855162.1736355678&_gl=1*1vvxju3*_ga*OTEyODU1MTYyLjE3MzYzNTU2Nzg.*_ga_TTB1J3Q9MN*MTc0MzExMzg0Ni4xMC4xLjE3NDMxMTM4NTcuNDkuMC4w",
            description: "Quickly search for a brand on Good on You and see it’s rating on the planet, people, and animals"
        },
        displayLinkProps2: {
            height: "192px",
            width: "410px",
            imageSrc: bcorpImg,
            linkImgSize: "160px",
            title: "Learn About B-Corp Brands",
            link: "https://usca.bcorporation.net/17-ethical-fashion-b-corps/",
            description: "Brands that are B-Corp Certified show that they meet high standards on social and environmental impact"
        },
        displayLinkProps3: {
            height: "192px",
            width: "410px",
            imageSrc: chooseManufactureImg,
            linkImgSize: "160px",
            title: "How to Make Sure You Choose a Sustainable Manufacturer for Your Fashion Brand",
            link: "https://blog.sourcingplayground.com/how-to-make-sure-you-choose-a-sustainable-manufacturer-for-your-fashion-brand/"
        },
        displayLinkProps4: {
            height: "192px",
            width: "410px",
            imageSrc: textileProducImg,
            linkImgSize: "160px",
            title: "The Impact of Textile Production and Waste on the Environment",
            link: "https://www.europarl.europa.eu/topics/en/article/20201208STO93327/the-impact-of-textile-production-and-waste-on-the-environment-infographics"
        },
        displayLinkProps5: {
            height: "192px",
            width: "410px",
            imageSrc: fashionPlagiarismImg,
            linkImgSize: "160px",
            title: "Plagiarism in Fashion: Why is There so much Counterfeiting",
            link: "https://fashionunited.uk/news/background/plagiarism-in-fashion-why-is-there-so-much-counterfeiting-and-is-it-even-allowed/2024022974359"
        },
        displayLinkProps6: {
            height: "192px",
            width: "410px",
            imageSrc: fashionEthicsImg,
            linkImgSize: "160px",
            title: "Ethical Practices in the Apparel and Textile Industry",
            link: "https://www.3-tree.com/blog/ethical-practices-in-the-apparel-and-textile-industry/"
        },
        displayLinkProps7: {
            height: "192px",
            width: "410px",
            imageSrc: factoryAuditImg,
            linkImgSize: "160px",
            title: "What Exactly Does It Mean When a Factory Is Audited?",
            link: "https://fashionista.com/2023/09/fashion-factory-labor-safety-audit"
        },
        personaCardImage: testImg
    },
    ecoEconomist: {
        personaImage: ecoEconomistPfp,
        whiteLogo: w_ecoEconomist,
        bg: bg_ecoEconomist,
        personaName: "ECO ECONOMIST",
        personaDescription: "The brand strategically focuses on preserving sustainable fashion production with lasting profitability.",
        pathTitle: "THE PATH TO SUSTAINABLE FASHION CONSUMPTION",
        displayLinkProps: {
            height: "192px",
            width: "410px",
            imageSrc: goodOnYouImg,
            linkImgSize: "160px",
            title: "Use a Fashion Brand Rater",
            link: "https://directory.goodonyou.eco/?_ga=2.200511335.814920322.1743113847-912855162.1736355678&_gl=1*1vvxju3*_ga*OTEyODU1MTYyLjE3MzYzNTU2Nzg.*_ga_TTB1J3Q9MN*MTc0MzExMzg0Ni4xMC4xLjE3NDMxMTM4NTcuNDkuMC4w",
            description: "Quickly search for a brand on Good on You and see it’s rating on the planet, people, and animals"
        },
        displayLinkProps2: {
            height: "192px",
            width: "410px",
            imageSrc: bcorpImg,
            linkImgSize: "160px",
            title: "Learn About B-Corp Brands",
            link: "https://usca.bcorporation.net/17-ethical-fashion-b-corps/",
            description: "Brands that are B-Corp Certified show that they meet high standards on social and environmental impact"
        },
        displayLinkProps3: {
            height: "192px",
            width: "410px",
            imageSrc: chooseManufactureImg,
            linkImgSize: "160px",
            title: "How to Make Sure You Choose a Sustainable Manufacturer for Your Fashion Brand",
            link: "https://blog.sourcingplayground.com/how-to-make-sure-you-choose-a-sustainable-manufacturer-for-your-fashion-brand/"
        },
        displayLinkProps4: {
            height: "192px",
            width: "410px",
            imageSrc: textileProducImg,
            linkImgSize: "160px",
            title: "The Impact of Textile Production and Waste on the Environment",
            link: "https://www.europarl.europa.eu/topics/en/article/20201208STO93327/the-impact-of-textile-production-and-waste-on-the-environment-infographics"
        },
        displayLinkProps5: {
            height: "192px",
            width: "410px",
            imageSrc: fashionPlagiarismImg,
            linkImgSize: "160px",
            title: "Plagiarism in Fashion: Why is There so much Counterfeiting",
            link: "https://fashionunited.uk/news/background/plagiarism-in-fashion-why-is-there-so-much-counterfeiting-and-is-it-even-allowed/2024022974359"
        },
        displayLinkProps6: {
            height: "192px",
            width: "410px",
            imageSrc: fashionEthicsImg,
            linkImgSize: "160px",
            title: "Ethical Practices in the Apparel and Textile Industry",
            link: "https://www.3-tree.com/blog/ethical-practices-in-the-apparel-and-textile-industry/"
        },
        displayLinkProps7: {
            height: "192px",
            width: "410px",
            imageSrc: factoryAuditImg,
            linkImgSize: "160px",
            title: "What Exactly Does It Mean When a Factory Is Audited?",
            link: "https://fashionista.com/2023/09/fashion-factory-labor-safety-audit"
        },
        personaCardImage: testImg
    },
    hiddenLabel: {
        personaImage: hiddenLabelPfp,
        whiteLogo: w_hiddenLabel,
        bg: bg_hiddenLabel,
        personaName: "HIDDEN LABEL",
        personaDescription: "The brand prioritized its own vision rather than appealing to the values of the Vanguards and the public.",
        pathTitle: "THE PATH TO SUSTAINABLE FASHION CONSUMPTION",
        displayLinkProps: {
            height: "192px",
            width: "410px",
            imageSrc: goodOnYouImg,
            linkImgSize: "160px",
            title: "Use a Fashion Brand Rater",
            link: "https://directory.goodonyou.eco/?_ga=2.200511335.814920322.1743113847-912855162.1736355678&_gl=1*1vvxju3*_ga*OTEyODU1MTYyLjE3MzYzNTU2Nzg.*_ga_TTB1J3Q9MN*MTc0MzExMzg0Ni4xMC4xLjE3NDMxMTM4NTcuNDkuMC4w",
            description: "Quickly search for a brand on Good on You and see it’s rating on the planet, people, and animals"
        },
        displayLinkProps2: {
            height: "192px",
            width: "410px",
            imageSrc: bcorpImg,
            linkImgSize: "160px",
            title: "Learn About B-Corp Brands",
            link: "https://usca.bcorporation.net/17-ethical-fashion-b-corps/",
            description: "Brands that are B-Corp Certified show that they meet high standards on social and environmental impact"
        },
        displayLinkProps3: {
            height: "192px",
            width: "410px",
            imageSrc: chooseManufactureImg,
            linkImgSize: "160px",
            title: "How to Make Sure You Choose a Sustainable Manufacturer for Your Fashion Brand",
            link: "https://blog.sourcingplayground.com/how-to-make-sure-you-choose-a-sustainable-manufacturer-for-your-fashion-brand/"
        },
        displayLinkProps4: {
            height: "192px",
            width: "410px",
            imageSrc: textileProducImg,
            linkImgSize: "160px",
            title: "The Impact of Textile Production and Waste on the Environment",
            link: "https://www.europarl.europa.eu/topics/en/article/20201208STO93327/the-impact-of-textile-production-and-waste-on-the-environment-infographics"
        },
        displayLinkProps5: {
            height: "192px",
            width: "410px",
            imageSrc: fashionPlagiarismImg,
            linkImgSize: "160px",
            title: "Plagiarism in Fashion: Why is There so much Counterfeiting",
            link: "https://fashionunited.uk/news/background/plagiarism-in-fashion-why-is-there-so-much-counterfeiting-and-is-it-even-allowed/2024022974359"
        },
        displayLinkProps6: {
            height: "192px",
            width: "410px",
            imageSrc: fashionEthicsImg,
            linkImgSize: "160px",
            title: "Ethical Practices in the Apparel and Textile Industry",
            link: "https://www.3-tree.com/blog/ethical-practices-in-the-apparel-and-textile-industry/"
        },
        displayLinkProps7: {
            height: "192px",
            width: "410px",
            imageSrc: factoryAuditImg,
            linkImgSize: "160px",
            title: "What Exactly Does It Mean When a Factory Is Audited?",
            link: "https://fashionista.com/2023/09/fashion-factory-labor-safety-audit"
        },
        personaCardImage: testImg
    },
};

export default personaData;